import Moment from 'moment'
import DatePicker from 'lightpick'


export default () => {
    const datePickerContainer = document.querySelector('#datepicker'),
        spanBegin = document.querySelector('.fake-input-datepicker .date-begin'),
        spanEnd = document.querySelector('.fake-input-datepicker .date-end');
    if(datePickerContainer == undefined){
        return
    }
    const datePicker = new DatePicker({
        field: datePickerContainer,
        parentEl : '.datepicker-container',
        secondField: datePickerContainer,
        numberOfMonths: 2,
        footer: false,
        onClose: () => {
            if( datePicker.getStartDate() != null && datePicker.getEndDate() != null ){
                let date = datePicker.getStartDate().format('DD/MM/Y') + '-' + datePicker.getEndDate().format('DD/MM/Y');
                datePickerContainer.value = date;
                spanBegin.innerText = datePicker.getStartDate().format('DD/MM/Y');
                spanEnd.innerText = datePicker.getEndDate().format('DD/MM/Y');
            }
        }
    });
}